module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("b4tzH"))).then(() => parcelRequire('d0iPb'));